import React from "react"
import type { Dispatch } from "react"
import type { BrindesFornecedorActions } from "./brindesFornecedorActions"
import type { BrindesFornecedorModel } from "../models/brindesFornecedorModel"
import { BrindesFornecedorInicial } from "../models/brindesFornecedorModel"

type ContextValue = {
    dados: BrindesFornecedorModel
    dispatch: Dispatch<BrindesFornecedorActions>
    erroCarregamento: string | null
}

export const BrindesFornecedorContext = React.createContext<ContextValue>({
    dados: BrindesFornecedorInicial,
    dispatch: () => undefined,
    erroCarregamento: null,
})
